storefrontApp.service('categoryElasticService', function () {
    this.buildSubcategoriesInfoRequest = function (prdDef, category,free) {
        if(free)
        return (
            req = '{"query":{"bool":{"must":[{"term":{"definitionName":"' + prdDef +
            '"}},{"term":{"listPrice":0}}]}},"from":0,"size":0,"aggs":{"categories":{"terms":{"field":"categoriesList.keyword","order":{"_key":"asc"},"size":1000}}}}'
        );
        else
        return (
            req = '{"query":{"bool":{"must":[{"term":{"definitionName":"' + prdDef +
            '"}},{"range":{"listPrice":{"gt":0}}}]}},"from":0,"size":0,"aggs":{"categories":{"terms":{"field":"categoriesList.keyword","order":{"_key":"asc"},"size":1000}}}}'
        );
    },
        this.buildCategorySamplesRequest = function (prdDef, category,free) {
                if(free)
                    return (
                        req = '{"sort":[{"saleRank":"desc"},{"rating":"desc"}],"query":{"bool":{"must":[{"term":{"definitionName":"' + prdDef +
                        '"}},{"term":{"categoriesList.keyword":"' + category + '"}},{"term":{"listPrice":0}}]}},"from":0,"size":36}'
                    );
                    else
                    return (
                        req = '{"sort":[{"saleRank":"desc"},{"rating":"desc"}],"query":{"bool":{"must":[{"term":{"definitionName":"' + prdDef +
                        '"}},{"term":{"categoriesList.keyword":"' + category + '"}},{"range":{"listPrice":{"gt":0}}}]}},"from":0,"size":36}'
                    );
        }

        this.buildPatchCategoryImagesRequest = function(categories){
            return (
                req = (
                        '{"size":0,'+
                        '"query":{"bool":{"must":[{"term":{"definitionName":"StockDesign"}},'+
                        '{"terms":{"categoriesList.keyword":' + angular.toJson(categories).toLowerCase() + '}},'+
                        '{"term":{"variants.isPatchEligible":true}},'+
                        '{"range":{"listPrice":{"gt":0}}}]}},'+
                        '"aggs":{"categories":{"terms":{"field":"categoriesList.keyword","size":4},'+
                        '"aggs":{"top_results":{"top_hits":{"size":6,'+
                        '"sort":[{"saleRank":"desc"},{"rating":"desc"}]}}}}}}'
                    )
            );
        }
});
